import _regeneratorRuntime from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { login as _login, aliexpressLogin as _aliexpressLogin, getInfo as _getInfo, refreshToken as _refreshToken, logout as _logout } from '@/api/auth/user';
import { getShopList as _getShopList } from '@/api/auth/shop';
import router, { resetRouter } from '@/router';
import { getAccessToken, setAccessToken, removeAccessToken, getRefreshToken, setRefreshToken, removeRefreshToken } from '@/utils/auth';
var state = {
  accessToken: getAccessToken(),
  refreshToken: getRefreshToken(),
  shops: [],
  info: undefined
};
var mutations = {
  SET_ACCESS_TOKEN: function SET_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken;
  },
  SET_REFRESH_TOKEN: function SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  SET_INFO: function SET_INFO(state, info) {
    state.info = info;
  },
  SET_SHOPS: function SET_SHOPS(state, shops) {
    state.shops = shops;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
        password = userInfo.password;
    return new Promise(function (resolve, reject) {
      _login({
        username: username.trim(),
        password: password
      }).then(function (response) {
        var data = response.data;
        commit('SET_ACCESS_TOKEN', data.access_token);
        commit('SET_REFRESH_TOKEN', data.refresh_token);
        setAccessToken(data.access_token);
        setRefreshToken(data.refresh_token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  aliexpressLogin: function aliexpressLogin(_ref2, code) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      _aliexpressLogin(code).then(function (resp) {
        var data = resp.data;
        commit('SET_ACCESS_TOKEN', data.access_token);
        commit('SET_REFRESH_TOKEN', data.refresh_token);
        setAccessToken(data.access_token);
        setRefreshToken(data.refresh_token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // refresh access token
  refreshToken: function refreshToken(_ref3, token) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_ACCESS_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      removeAccessToken();
      removeRefreshToken();

      _refreshToken(token).then(function (resp) {
        var data = resp.data;
        commit('SET_ACCESS_TOKEN', data.access_token);
        commit('SET_REFRESH_TOKEN', data.refresh_token);
        setAccessToken(data.access_token);
        setRefreshToken(data.refresh_token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      _getInfo().then( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resp) {
          var user, roles, accessRoutes;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  user = resp.data;

                  if (!user) {
                    reject('Verification failed, please Login again.');
                  }

                  roles = user.roles;
                  resetRouter();
                  _context.next = 6;
                  return dispatch('permission/generateRoutes', roles, {
                    root: true
                  });

                case 6:
                  accessRoutes = _context.sent;
                  router.addRoutes(accessRoutes);
                  commit('SET_INFO', user);
                  resolve(user);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return new Promise(function (resolve, reject) {
      _logout().then(function () {
        commit('SET_ACCESS_TOKEN', '');
        commit('SET_REFRESH_TOKEN', '');
        commit('SET_INFO', '');
        commit('SET_SHOPS', []);
        removeAccessToken();
        removeRefreshToken();
        resetRouter();
        resolve();
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_ACCESS_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      removeAccessToken();
      removeRefreshToken();
      resolve();
    });
  },
  getShopList: function getShopList(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      _getShopList().then(function (resp) {
        var data = resp.data;
        commit('SET_SHOPS', data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};